<template>
  <div>
    <higherSearchModel :forSonTerms="allTerms" @sendTerms="getTerms"></higherSearchModel>
  </div>
</template>

<script>
import { getMessageListForNode } from '@/api/customer.js'
import higherSearchModel from './../common/higher-search-model.vue'
export default {
  name: '',
  props: ['contents'],
  data () {
    return {
      search: {
        status: 2
      },
      page: 1,
      allTerms: this.contents.allTerms
    }
  },
  computed: {
  },
  methods: {
    // 获取查询的值
    getTerms(value) {
      // 传值到父组件
      let choose = {}
      choose.nodeType = 'attrJudgeNode'
      choose.allTerms = value
      choose.id = this.contents.id
      this.$emit('sendSearchTerms', choose)
    }
  },
  watch: {
    contents: function (val) {
      this.allTerms = val.allTerms
    }
  },
  components: {
    higherSearchModel
  },
  created() {
  }
}
</script>

<style scoped>
</style>
